// action types
export const ADD_HEADER_SETTINGS = "ADD_HEADER_SETTINGS";

// mutation types
export const SET_HEADER_SETTINGS = "SET_HEADER_SETTINGS";